// extracted by mini-css-extract-plugin
export default {"container":"TeamMemberDayTimelineEntry_container__Ym3r8"};